var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { Tile as TileCard } from '../molecules/Tile';
export var Tiles = function (_a) {
    var sectionTitle = _a.sectionTitle, tiles = _a.tiles;
    var navigate = useNavigate();
    return (_jsx(_Fragment, { children: tiles.map(function (tile) {
            var handleTileLinkClick = function () {
                navigate(tile.externalUrl || '');
            };
            return (_jsx(TileCard, __assign({ title: tile.title, subtitle: tile.description, ctaText: "Find out more", ctaHandler: handleTileLinkClick }, { children: "".concat(tile.title, " | ").concat(tile.description) }), "".concat(sectionTitle, "-tiles-").concat(tile.slug)));
        }) }));
};
